
import Vue, { PropType } from "vue";
import axios from "axios";
import { UserMessage } from '../../../types/Sapphire_dto';

export default Vue.extend({
    name: "message-viewer",
    props: {
        message: Object as PropType<UserMessage>,
        usr: String,
        fac: String
    },
    methods: {
        closeMessageViewer() {
            this.$emit('hideviewer');
        },
        formatRecipients: function (msg: UserMessage) {
            var recipientStr = "";

            for (var i = 0; i < msg.MessageRecipients.length; ++i) {
                let rep = msg.MessageRecipients[i];
                var currentUser = "";
                if (i !== 0) {
                    currentUser += ", ";
                }
                currentUser += String.stringFormat("{0} {1} ({2})", rep.FirstName, rep.LastName, rep.UserName);

                recipientStr += currentUser;
            }

            return recipientStr;
        },
        formatSender: function (msg: UserMessage) {
            return String.stringFormat("{0} {1} ({2})", msg.SenderFirstName, msg.SenderLastName, msg.SenderUserName);
        },
        formatSentDate(dte: Date): string {
            let options: Intl.DateTimeFormatOptions = {
                year: "numeric",
                month: "numeric",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                timeZone: 'America/New_York',
                timeZoneName: "short",
            };
            return new Intl.DateTimeFormat("en-us", options).format(dte);
         },
        refreshMessages: function () {
            this.$emit('refresh', 1, 10);
        },
        forwardMessage() {
            this.closeMessageViewer();
            this.$emit('forward', this.message);
        },
        replyAllMessage() {
            this.closeMessageViewer();
            this.$emit('replyall', this.message);
        },
        replyMessage() {
            this.closeMessageViewer();
            this.$emit('reply', this.message);
        },
        async saveMessage() {
            try {
                await axios.post("../../Common/Services/EmarClientOperations.svc/SetSavedMessages",
                {
                    messageID: this.message.MessageID,
                    userID: this.usr,
                    facilityID: this.fac
                });
                this.closeMessageViewer();
                this.refreshMessages();

            } catch (err) {
                this.$swal('Error', 'There was an error saving the message.', 'error');
            }
        },
        async deleteMessage() {
             try {
                await axios.post("../../Common/Services/EmarClientOperations.svc/SetDeleteMessage",
                {
                    messageID: this.message.MessageID,
                    userID: this.usr,
                    facilityID: this.fac
                });
                this.closeMessageViewer();
                this.refreshMessages();

            } catch (err) {
                this.$swal('Error', 'There was an error deleting the message.', 'error');
            }
        },
        parseMessageBody(encodedHTML: string) {
            var dp = new DOMParser;
            var dom = dp.parseFromString(encodedHTML, "text/html");
            if (dom && dom.body && dom.body.textContent && dom.body.textContent.length > 0) {
                return dp.parseFromString(dp.parseFromString(dom.body.textContent, "text/html").body.textContent, "text/html").body.textContent;
            } else {
                return '';
            }
        }
    }
})
